import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import { DEFAULT_PARTICLES_FLICKERING_SETTINGS } from '../../../../CreatePageConstants';
import { Chip, Tooltip, ListItem, ListItemText, Box, Switch } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';

const styles = {
    labelContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: 1
    },
    warningChip: {
        height: 20,
        '& .MuiChip-icon': {
            fontSize: '15px',
            marginLeft: '6px',
            marginRight: '-4px',
        },
        '& .MuiChip-label': {
            paddingLeft: '6px',
            paddingRight: '8px',
            fontSize: '0.75rem',
            lineHeight: 1,
            display: 'flex',
            alignItems: 'center'
        }
    }
};

const ParticlesReactiveFlickerListItem = (props) => {
    const { index, updateParticleElement, flickering } = props;

    const onReactiveFlickerChange = (event) => {
        updateParticleElement(index, { 
            flickering: { 
                ...flickering, 
                reactive: event.target.checked 
            } 
        });
    };

    return (
        <ListItem>
            <ListItemText>
                <Box sx={styles.labelContainer}>
                    <span>Reactive Flicker</span>
                    <Tooltip 
                        title="Particles will flicker faster during loud audio when this is enabled. This can result in rapid flashing of particles."
                        placement="top"
                    >
                        <Chip
                            icon={<WarningIcon />}
                            label="Rapid Flashing"
                            size="small"
                            variant="outlined"
                            color="warning"
                            sx={styles.warningChip}
                        />
                    </Tooltip>
                </Box>
            </ListItemText>
            <Box>
                <Switch
                    checked={flickering?.reactive ?? DEFAULT_PARTICLES_FLICKERING_SETTINGS.reactive}
                    onChange={onReactiveFlickerChange}
                    color='primary'
                />
            </Box>
        </ListItem>
    );
};

const mapStateToProps = (state, ownProps) => {
    const particleElement = state.createPreview.present.videoSettings.elements.particles.items[ownProps.index];

    return {
        flickering: particleElement.flickering || {}
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateParticleElement = (index, properties) => dispatch(createActions.updateParticleElement(index, properties));
    return { updateParticleElement }
}

export default connect(mapStateToProps, mapDispatchToProps)(ParticlesReactiveFlickerListItem);